'use client';

import { useState } from 'react';
import { useLanguage } from "@/providers/LanguageContext";
import styles from "../app/page.module.css";

export function FAQSection() {
  const { language } = useLanguage();
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqItems = [
    {
      question: language === "es" ? "¿Cuánto cuesta?" : "How much does it cost?",
      answer: language === "es"
        ? "Los precios de nuestros cursos son competitivos dado el número de horas de instrucción. Los precios oscilan entre 150-175 Soles para clases de niños y clases de inglés general en nuestro centro de idiomas de Oxapampa. Los cursos de preparación para exámenes oscilan entre 180-225 Soles dependiendo del nivel."
        : "The prices of our courses are competitive given the number of hours of instruction. Prices range between 150-175 Soles for children's classes and general English classes in our Oxapampa language center. Exam preparation courses range from 180-225 Soles depending on the level."
    },
    {
      question: language === "es" ? "¿Cómo se imparten las clases?" : "How are the classes given?",
      answer: language === "es"
        ? "Todos nuestros cursos de inglés para niños, adultos y preparación para exámenes se imparten en nuestro centro de idiomas de Oxapampa. Ofrecemos grupos pequeños para garantizar atención personalizada para cada estudiante."
        : "All our English courses for children, adults, and exam preparation are given in our Oxapampa language center. We offer small group sizes to ensure personalized attention for every student."
    },
    {
      question: language === "es" ? "¿Obtengo un certificado?" : "Do I get a certificate?",
      answer: language === "es"
        ? "¡Sí! Nos tomamos nuestros cursos en serio y queremos que tú también lo hagas. Todos los estudiantes que aprueben el curso con una C o superior recibirán un Certificado de Finalización con una calificación. Para los cursos de preparación para exámenes, los estudiantes también tendrán la oportunidad de realizar un examen oficial internacional de inglés y recibir un certificado reconocido internacionalmente."
        : "Yes! We take our courses seriously and we want you to also! All students who pass the course with a C or higher will receive a Certificate of Completion with a grade. For exam preparation courses, students will also have the opportunity to take an official international English exam and receive an internationally recognized certificate."
    },
    {
      question: language === "es" ? "¿Cómo realizo el pago?" : "How do I make payment?",
      answer: language === "es"
        ? "Aceptamos efectivo, Yape y transferencias bancarias dentro de Perú."
        : "We accept cash, Yape and bank transfers within Peru."
    },
    {
      question: language === "es" ? "¿Dan descuentos familiares?" : "Do you give family discounts?",
      answer: language === "es"
        ? "¡Sí! Si estás inscribiendo a varios niños o miembros de la familia, ofrecemos descuentos significativos. También proporcionamos descuentos para escuelas y organizaciones que buscan inscribir a múltiples estudiantes."
        : "Yes! If you're enrolling multiple children or family members, we offer significant discounts. We also provide discounts for schools and organizations looking to enroll multiple students."
    }
  ];

  return (
    <div className={styles.faqSection}>
      <div className={styles.faqShell}>
        <h2 className={`${styles['features-title']} ${styles.sectionTitleCentered}`}>
          {language === "es" ? "Preguntas Frecuentes" : "FAQs"}
        </h2>

        <div className={styles.accordion}>
          {faqItems.map((item, index) => (
            <div className={styles['accordion-item']} key={index}>
              <button 
                onClick={() => toggleFaq(index)}
                className={`${styles.faqButton} ${openFaq === index ? styles.active : ''}`}
              >
                {item.question}
                <span className={`${styles.faqIcon} ${openFaq === index ? styles.faqIconOpen : ''}`}>
                  ▼
                </span>
              </button>
              <div 
                className={`${styles.faqPanel} ${openFaq === index ? styles.faqPanelOpen : styles.faqPanelClosed}`}
              >
                <p className={styles.faqAnswer}>
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
